/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * The browsers targeted by this application are defined in `.browserslistrc`
 * (evergreen browsers only - no Internet Explorer). Anything those browsers
 * implement natively must NOT be polyfilled here.
 *
 * Learn more in https://angular.dev/reference/versions#browser-support
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

//  (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
//  (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
//  (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Some third-party CommonJS bundles expect a Node-style `global` object.
 */
(window as any).global = window;
